<template>
  <div class="mb-base">
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir valider la supression du collaborateur ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="accept()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button class="mt-2 w-full" @click="decline()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
	<FilterCard :refreshKey="1" :filters="filtersTemplates" :showListLength="displayedCollaborators.length" @filter="handleFilterEmits($event)" :actions="actionsTemplates" @action="handleActionEmits($event)" :onChangeEmit="true" />

    <vx-card style="max-height:69vh; overflow: auto;">
      <div class="vx-row">
        <template
          v-for="(collaborator, index) in displayedCollaborators">

        <div
          v-if="collaborator"
          class="vx-col mb-base"
          :key="index"
        >


         <!-- COLLABORATOR CARD -->
          <vx-card class="p-2" style="width: 300px;" v-if="collaborator">
            <!-- AVATAR -->
            <div class="vx-row">
              <vs-avatar
                style="border: 1px solid;"
                class="mx-auto mb-6 block"
                size="80px"
                :src="getCollaboratorAvatar(collaborator.id)"
              />
            </div>
            <!-- FULL NAME AND TITLE -->
              <div class="text-center vx-row mx-auto justify-center">
                <h4>{{ collaborator.firstname }} {{ collaborator.lastname }}</h4>
              </div>
              <div class="text-center vx-row mx-auto justify-center">
                <p>{{ getUserTitle(collaborator.type) }}</p>
              </div>
              <div class="text-center vx-row mx-auto justify-center">
                <vs-chip
                  style="width: 80px"
                  :color="getContractStatusColor(collaborator.status)"
                  class="ml-2"
                  >{{
                  getStatus(collaborator.status)
                }}</vs-chip>
              </div>
            <!-- PHONE -->
            <div class="vx-row mt-2 flex justify-between">
              <div class="flex items-center">
                <span class="ml-2">Tél : {{ collaborator.phone }}</span>
              </div>
            </div>
            <!-- MAIL -->
            <div class="vx-row flex justify-between">
              <div class="flex items-center">
                <span class="ml-2">Email : <a :href="'mailto:' + collaborator.email">{{ collaborator.email }}</a></span>
              </div>
            </div>
            <!-- COMMENT -->
            <!-- <div class="vx-row flex justify-between">
              <div class="flex items-center">
                <span class="ml-2">Commentaire : {{ collaborator.commentary }}</span>
              </div>
            </div> -->
            <!-- BUTTONS -->
            <div
              class=" vx-row flex justify-between flex-wrap"
              v-if="$acl.check('admin')"
            >
              <vs-button
				v-if="$acl.check('sadmin')"
                color="primary"
                class="mt-4 shadow-lg vx-col w-1/3"
                icon-pack="feather"
                icon="icon-edit"
                @click="modifyCollaborator(collaborator.id)"
              />
			<vs-button
				v-else-if="$acl.check('admin') && ![6,9].includes(collaborator.type)"
                color="primary"
                class="mt-4 shadow-lg vx-col w-1/3"
                icon-pack="feather"
                icon="icon-edit"
                @click="modifyCollaborator(collaborator.id)"
              />
              <vs-button
				v-if="$acl.check('sadmin')"
                class="mt-4 mr-2 vx-col w-1/3"
                type="border"
                color="danger"
                icon-pack="feather"
                icon="icon-trash-2"
                @click="displayValidationPopup(collaborator.id)"
                />
            </div>
          </vx-card>
        </div>
        </template>
      </div>

    </vx-card>
  </div>
</template>

<script>
import fieldConvertorMixin from "@/mixins/dbFieldConvertorMixin";
import FilterCard from "@/views/filters/FilterCard";
import store from "@/store/store";

import "@/assets/css/toggle-switch.css";
import XLSX from "xlsx";

export default {
	name: "CollaboratorDashboard",
	mixins: [fieldConvertorMixin],
	components: {FilterCard},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			showPassPopup: false,
			selectedCollaborator: null,
			nameFilter: "",
			functionFilter: "",
			activeFilter: "",
			nameFilterOn: false,
			functionFilterOn: false,
			activeFilterOn: false,
			displayedCollaboratorsFull: [],
			displayedCollaborators: [],
			functionList: [
				{
					id: 7,
					text: "Collaborateur externe"
				},
				{
					id: 8,
					text: "Comptabilité"
				},
				{
					id: 3,
					text: "Consultant"
				},
				{
					id: 4,
					text: "Sales"
				},
				{
					id: 5,
					text: "Technique"
				},
				{
					id: 6,
					text: "Administrateur"
				},
				{
					id: 9,
					text: "Super Administrateur"
				}],
			showValidationPopup: false,
			actionsTemplates: [{
				order: 1,
				emitSlugName: "new_collaborator",
				buttonName: "Ajouter un collaborateur",
				buttonIcon: "icon-plus-circle",
				buttonColor: "primary",
			}, {
				order: 2,
				emitSlugName: "action_extract_collaborators",
				buttonName: "Exporter",
				buttonIcon: "icon-download-cloud",
				buttonColor: "dark",
			}],
			filtersTemplates: [
				{
					order: 3,
					emitSlugName: "filter_isActive",
					filterPlaceHolder: "",
					value: "",
					type: "Slider",
					params: {
						off: "Inactif",
						default: "Tous",
						on: "Actif"
					}
				}, {
					order: 1,
					emitSlugName: "filter_name",
					filterPlaceHolder: "Prénom Nom",
					value: "",
					type: "Input",
				}, {
					order: 2,
					emitSlugName: "filter_poste",
					filterPlaceHolder: "Postes",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [
							{
								id: 7,
								name: "Collaborateur externe"
							},
							{
								id: 8,
								name: "Comptabilité"
							},
							{
								id: 3,
								name: "Consultant"
							},
							{
								id: 4,
								name: "Sales"
							},
							{
								id: 5,
								name: "Technique"
							},
							{
								id: 6,
								name: "Administrateur"
							},
							{
								id: 9,
								name: "Super Administrateur"
							}
						]
					}
				}],

		};
	},
	created() {
		this.getAllCollaborators();
		this.getAllCollaboratorsAvatar();
	},
	mounted(){
		this.displayedCollaborators = this.displayCollaborators(this.collaborators);
		this.displayedCollaboratorsFull = this.displayCollaborators(this.collaborators);
	},
	computed: {
		collaborators: function() {
			return this.$store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	watch: {
		collaborators: function(){
			//console.log("collaborators watch");
			this.displayedCollaborators = [];
			this.displayedCollaborators = this.displayCollaborators(this.collaborators);
			this.displayedCollaboratorsFull = this.displayCollaborators(this.collaborators);
			this.displayedCollaborators = this.filterCollaborators(this.displayedCollaboratorsFull);
		},
		nameFilter: function() {
			if(this.nameFilter == "") {
				this.nameFilterOn = false;
			}
			else{
				this.nameFilterOn = true;
			}
			////console.log("nameFilter")
			this.displayedCollaborators = this.filterCollaborators(this.displayedCollaboratorsFull); //A CHANGER
		},
		functionFilter: function() {
			this.functionFilterOn = true;
			////console.log("activeFilter")
			this.displayedCollaborators = this.filterCollaborators(this.displayedCollaboratorsFull); //A CHANGER
		}
		/*
		 * activeFilter: function() {
		 *   this.activeFilterOn = true
		 *   ////console.log("activeFilter")
		 *   this.displayedCollaborators = this.filterCollaborators(this.displayedCollaboratorsFull) //A CHANGER
		 * },
		 */
	},
	methods: {
		setRowNum(len){
			store.dispatch("setRowNum", len);
		},
		/**
		 * Query our API to fetch all the collaborators (mainly from Rankwell's team)
		 */
		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		/**
		 * Query our API to fetch all the rankwell collaborators avatar
		 */
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(row => row.emitSlugName == receivedEmit[0]);
			if(templateRowIndex >= 0) this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch(receivedEmit[0]){
			case"filter_name":
				this.nameFilter = receivedEmit[1].value;
				break;
			case"filter_poste":
				this.functionFilter = receivedEmit[1].value;
				break;
			case"filter_isActive":
				this.refreshActiveFilterValue(receivedEmit[1].value);
				break;
			default:
				break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit){
			//console.log(receivedEmit);
			// Find template value
			switch(receivedEmit[0]){
			case"action_extract_collaborators":
				this.exportData(this.displayedCollaborators);
				break;
			case"new_collaborator":
				// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
				this.$router.push({name: "new_entity"});
				break;
			default:
				break;
			}
		},

		refreshActiveFilterValue(value){
			this.activeFilter = value;
			this.activeFilterOn = this.activeFilter === "" ? false : true;
			this.displayedCollaborators = this.filterCollaborators(this.displayedCollaboratorsFull); //A CHANGER
		},

		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet(){
			////console.log("isFilterSet BEGIN")
			if(this.functionFilterOn || this.nameFilterOn || this.activeFilterOn) return true;
			return false;
		},

		/**
		 * Return list of filtered providers A CHANGER
		 * @param {String} nameFilterOn - Society is active?
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} expertiseFilterOn - Id of the commercial in charge of the project
		 * @return {List} - Societies' list filtered
		 */
		filterCollaborators(collaborators){
			////console.log("filterProviders BEGIN")
			let collaboratorsList = [];

			let searchKeyList = {};
			this.functionFilterOn ? searchKeyList["functionFilter"] = this.functionFilter : false;
			this.nameFilterOn ? searchKeyList["nameFilter"] = this.nameFilter.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
			this.activeFilterOn ? searchKeyList["activeFilter"] = this.activeFilter : false;

			for(let collaboratorToFilter of collaborators){
				////console.log(providerToFilter)
				let name = "";

				if(collaboratorToFilter.firstname) name += collaboratorToFilter.firstname.toLowerCase();
				if(collaboratorToFilter.lastname) name += collaboratorToFilter.lastname.toLowerCase();

				let providerSearchKeyList = {};
				this.functionFilterOn ? providerSearchKeyList["functionFilter"] = collaboratorToFilter.type : false;
				this.nameFilterOn ? providerSearchKeyList["nameFilter"] = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : false;
				this.activeFilterOn ? providerSearchKeyList["activeFilter"] = collaboratorToFilter.status : false;

				let check = true;

				for(let key in searchKeyList) {
					/*
					 * //console.log("TYPE")
					 * //console.log(typeof providerSearchKeyList[key])
					 */
					if(typeof searchKeyList[key] == "string"){
						if(typeof providerSearchKeyList[key] == "string"){
							if(!providerSearchKeyList[key].includes(searchKeyList[key])){
								check = false;
								break;
							}
						}
						else if(typeof providerSearchKeyList[key] == "object"){
							////console.log("Array")
							let checkLoop = false;
							for(let value of providerSearchKeyList[key]){
								let service_name = this.getServiceIdToName(value).toLowerCase();
								/*
								 * //console.log(service_name)
								 * //console.log(searchKeyList[key])
								 */
								if(service_name.includes(searchKeyList[key])){
									////console.log("checkLoop = true;")
									checkLoop = true;
								}
							}
							if(!checkLoop){
								check = checkLoop;
								break;
							}
						}
					}
					else{
						if(providerSearchKeyList[key] != searchKeyList[key]){
							check = false;
							break;
						}
					}
				}

				if(check) collaboratorsList.push(collaboratorToFilter);
			}

			let keyConvertor = new Array();

			for(let i = 0; i < collaboratorsList.length; i++){
				keyConvertor[collaboratorsList.indexOf(collaboratorsList[i]) + collaboratorsList.length] = collaboratorsList[i];
				delete keyConvertor[collaboratorsList.indexOf(collaboratorsList[i]) - collaboratorsList.length];
			}
			return keyConvertor;
		},

		displayCollaborators(collaborators){
			let collaboratorsList = [];
			if(this.displayedCollaborators.length > 0){
				collaboratorsList = this.displayedCollaborators;
			}
			else{
				if(!this.isFilterSet()){
					collaboratorsList = collaborators;
				}
			}
			return collaboratorsList;
		},

		/**
		 * Open form to modify the collaborator passed in argument
		 * @param {Number} collaboratorId - Collaborator ID to modify
		 */
		modifyCollaborator(collaboratorId){
			let updateEntityForm = "collaborator";
			this.$router.push({name: "update_entity", params: {collaboratorId, updateEntityForm}});
			//console.log("modifyCollaborator");
		},

		// /**
		//  * Open form to delete the collaborator passed in argument
		//  * @param {Number} collaboratorId - Collaborator ID to delete
		//  */
		deleteCollaborator(collaboratorId){
			//console.log(collaboratorId);
			this.$http.delete(this.apiUrl + "users/delete", {
				data: {
					id: collaboratorId
				}
			})
				.then(() => {
					// Send a success notification to the user
					this.$vs.notify({
						title: "Succès",
						text: "Collaborateur effacé avec succès."
					});
					// Refresh List
					this.getAllCollaborators();
					this.getAllCollaboratorsAvatar();
				})
				.catch(err => {
					//console.log(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Le collaborateur n'a pas été effacé."
					});
				});
		},

		displayValidationPopup(collaboratorId){
			this.selectedCollaborator = collaboratorId;
			this.showValidationPopup = true;
		},
		accept(){
			this.deleteCollaborator(this.selectedCollaborator);
			this.showValidationPopup = false;
		},
		decline(){
			this.selectedCollaborator = null;
			this.showValidationPopup = false;
		},
		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				this.$delete(data[i], "image_url");
				data[i]["status"] = this.getStatus(data[i]["status"]);
				data[i]["type"] = this.getUserTitle(data[i]["type"]);

				if(data[i]["phone"] !== null){
					data[i]["phone"] = data[i]["phone"].replace(/\s*/g, "");
					data[i]["phone"] = data[i]["phone"].replace("(0)", "0");
					data[i]["phone"].length == 9 ? data[i]["phone"] = "0" + data[i]["phone"]: "";
				}

				for(let x in data[i]){
					data[i][x] = String(data[i][x]).trim();
				}
			}

			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "collaborator";

			let header = {
				header: [
					"id",
					"firstname",
					"lastname",
					"email",
					"phone",
					"status",
					"type",
					"commentary",
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				id: "Identifiant",
				firstname: "Prénom",
				lastname: "Nom",
				email: "Email",
				phone: "Téléphone",
				status: "Statut",
				type: "Accès",
				commentary: "Commentaire",
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Collaborator_export.xls");
		},
	}
};
</script>
<style lang="scss">
.table-filter{
	.con-tablex.vs-table--content{
		.vs-con-tbody.vs-table--tbody > table{
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead{
				display: none;
			}
			tr{
				.td-check{
					width: 40px;
				}
				td{
					border: none;
				}
			}
			.tr-expand > td > div{
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table{
				display: none;
			}
		}
		.not-data-table.vs-table--not-data{
			display: none;
		}
	}
}
</style>